import {ModelEvents} from '@denishussar/html5-game-engine';
import {CrazyGamesAds, CrazyGamesAdsAssoc, CrazyGamesAdsType} from '../../Common/CrazyGamesAds/CrazyGamesAds';
import {GameEvent, GameEventAdAbort, GameEventAdComplete, GameEventAdStart} from '../../Constants/GameEvent';
import {GameModel} from '../../Models/GameModel';
import {GameLogic} from '../GameLogic';
import {ADS_TYPE} from "../../Common/Ads/AdsType";
import {BaseAdsLogic, REWARDED_ADS_TYPE} from "../Ads/BaseAdsLogic";

export class CrazyGamesAdsLogic extends BaseAdsLogic {
    protected isSDKReady = true;
    private _sdk: CrazyGamesAds = null;

    constructor(
        private _modelEvents: ModelEvents,
        private _model: GameModel,
        private _gameLogic: GameLogic,
    ) {
        super();
        this._sdk = new CrazyGamesAds();

        window.addEventListener("wheel", (event) => event.preventDefault(), {
            passive: false,
        });

        window.addEventListener("keydown", (event) => {
            if (["ArrowUp", "ArrowDown", " "].includes(event.key)) {
                event.preventDefault();
            }
        });
    }

    protected async onRequestAd(type: ADS_TYPE): Promise<void> {
        const crazyAdType = CrazyGamesAdsAssoc[type];
        if (!this._sdk.requestAd(crazyAdType)) {
            console.error('CrazyGamesAdsLogic::', 'Can not get ad from CrazySDK');
            throw new Error("Can not get ad from CrazySDK");
        }

        if (crazyAdType === CrazyGamesAdsType.reward) {
            this._modelEvents.dispatch(this._model, GameEvent.adStart, <GameEventAdStart>{
                id: crazyAdType,
                time: 0,
            });
        } else if (crazyAdType === CrazyGamesAdsType.interstitial) {
            this._modelEvents.dispatch(this._model, GameEvent.interstitialStart, <GameEventAdStart>{
                id: crazyAdType,
                time: 0,
            });
        }

        return new Promise((resolve, reject) => {
            this._sdk.onFinished = () => {
                this._sdk.onStarted = null;
                this._sdk.onFinished = null;
                this._sdk.onError = null;

                if (crazyAdType === CrazyGamesAdsType.reward) {
                    this.restartRewardedAdTimeout(REWARDED_ADS_TYPE.COMMON);
                    this._modelEvents.dispatch(this._model, GameEvent.adComplete, <GameEventAdComplete>{
                        id: crazyAdType,
                        time: 0,
                        skip: false,
                        popupName: this._gameLogic.modalsManager.getCurrentKey(),
                    });
                } else if (crazyAdType === CrazyGamesAdsType.interstitial) {
                    this._modelEvents.dispatch(this._model, GameEvent.interstitialComplete, <GameEventAdComplete>{
                        id: crazyAdType,
                        time: 0,
                        skip: false,
                        popupName: this._gameLogic.modalsManager.getCurrentKey(),
                    });
                }

                resolve();
            };

            this._sdk.onError = (e: {error: string}) => {
                this._sdk.onStarted = null;
                this._sdk.onFinished = null;
                this._sdk.onError = null;

                if (crazyAdType === CrazyGamesAdsType.reward) {
                    this._modelEvents.dispatch(this._model, GameEvent.adAbort, <GameEventAdAbort>{
                        id: crazyAdType,
                        time: 0,
                        skip: false,
                        popupName: this._gameLogic.modalsManager.getCurrentKey(),
                        cause: 'SDK Error',
                        message: e?.error
                    });
                } else if (crazyAdType === CrazyGamesAdsType.interstitial) {
                    this._modelEvents.dispatch(this._model, GameEvent.interstitialAbort, <GameEventAdAbort>{
                        id: crazyAdType,
                        time: 0,
                        skip: false,
                        popupName: this._gameLogic.modalsManager.getCurrentKey(),
                        cause: 'SDK Error',
                        message: e?.error
                    });
                }

                console.error('CrazyGamesAdsLogic::', e);
                reject();
            };
        })
    }

    protected onClearAllBanners(): void {
        this._sdk.clearBanner('banner-container');
        this._sdk.clearAllBanners();
    }

    protected onGameplayStart() {
        this._sdk.gameplayStart();
    }

    protected onGameplayStop() {
        this._sdk.gameplayStop();
    }
}
